<template>
    <div class="main-header" style="background-color: #0a142d !important;">
        <a href="#mobile-menu-01" data-toggle="collapse" class="mobile-menu-toggle">
            Mobiles Menü umschalten
        </a>

        <!-- Begin:Navbar-topnav -->
        <div class="container">
            <h1 class="logo navbar-brand">
                <a href="/index.php"> <img src="/res/images/logo.png" alt="Sundair" /></a>
            </h1>

            <nav id="main-menu" role="navigation">
                <ul class="menu">
                    <li class="menu-item" v-bind:class="{ active: getPathName('booking') }"><a href="/booking/">{{ booking[getCurrentLocale] }}</a></li>
                    <!-- <li class="menu-item" v-bind:class="{ active: getPathName('services') }"><a href="/services/">{{ services[getCurrentLocale] }}</a></li>
                    <li class="menu-item" v-bind:class="{ active: getPathName('rebooking') }"><a href="/rebooking/">{{ rebooking[getCurrentLocale] }}</a></li>
                    <li class="menu-item" v-bind:class="{ active: getPathName('flightstatus') }"><a href="/flightstatus/">{{ flightstatus[getCurrentLocale] }}</a></li>
                    <li class="menu-item" v-bind:class="{ active: getPathName('career') }"><a href="/career/">{{ career[getCurrentLocale] }}</a></li>
                    <li class="menu-item" v-bind:class="{ active: getPathName('flightplan') }"><a href="/flightplan/">{{ flightplan[getCurrentLocale] }}</a></li> -->
                    <!-- <li class="menu-item" v-bind:class="{ active: getPathName('webshop') }"><a href="/webshop/" id="_new">{{ webshop[getCurrentLocale] }}</a></li> -->

                    <!-- <li class="menu-item" v-bind:class="{ active: getPathName('travelcenter') }" style="margin-left: 30px;">
                        <a href="/travelcenter" style="font-weight: 900; font-size: 13px;">{{ travelcenter[getCurrentLocale] }}</a>
                    </li>

                    <li class="menu-item" v-bind:class="{ active: getPathName('agency') }" style="margin-left: 30px;" v-if="getFlagSharedAgencyLoggedIn === true">
                        <a href="/agency" style="font-weight: 900; font-size: 13px;">{{ agency[getCurrentLocale] }}</a>
                    </li> -->
                </ul>
            </nav>
        </div>
        <!-- End:Navbar-topnav -->


        <!-- Begin:Navbar-mobile -->
        <nav id="mobile-menu-01" class="mobile-menu collapse">
            <ul id="mobile-primary-menu" class="menu">
                <li class="menu-item" v-bind:class="{ active: getPathName('booking') }"><a href="/booking/">{{ booking[getCurrentLocale] }}</a></li>
                <!-- <li class="menu-item" v-bind:class="{ active: getPathName('services') }"><a href="/services/">{{ services[getCurrentLocale] }}</a></li>
                <li class="menu-item" v-bind:class="{ active: getPathName('rebooking') }"><a href="/rebooking/">{{ rebooking[getCurrentLocale] }}</a></li>
                <li class="menu-item" v-bind:class="{ active: getPathName('flightstatus') }"><a href="/flightstatus/">{{ flightstatus[getCurrentLocale] }}</a></li>
                <li class="menu-item" v-bind:class="{ active: getPathName('career') }"><a href="/career/">{{ career[getCurrentLocale] }}</a></li>
                <li class="menu-item" v-bind:class="{ active: getPathName('flightplan') }"><a href="/flightplan/">{{ flightplan[getCurrentLocale] }}</a></li> -->
                <!-- <li class="menu-item" v-bind:class="{ active: getPathName('webshop') }"><a href="/webshop/">{{ webshop[getCurrentLocale] }}</a></li> -->

                <!-- <li class="menu-item" v-bind:class="{ active: getPathName('agency') }" v-if="getFlagSharedAgencyLoggedIn === true"><a href="/agency">{{ agency[getCurrentLocale] }}</a></li> -->
            </ul>

            <ul class="mobile-topnav container">
                <li class="ribbon language menu-color-skin">
                    <a href="#">{{ language[getCurrentLocale] }} ({{ lang }})</a>
                    <ul class="menu mini">
                        <li v-bind:class="{ active: lang === 'de' }">
                            <a href="#" title="Deutsch" v-on:click.prevent="changeLanguage('de')">Deutsch</a>
                        </li>
                        <li v-bind:class="{ active: lang === 'en' }">
                            <a href="#" title="English" v-on:click.prevent="changeLanguage('en')">English</a>
                        </li>

                        <v-dialog/>
                    </ul>
                </li>


                <!-- <li v-if="getFlagSharedAgencyLoggedIn === false">
                    <a href="#sundair-login" class="soap-popupbox">{{ agencylogin[getCurrentLocale] }}</a>
                </li>
                <li v-if="getFlagSharedAgencyLoggedIn === true">
                    <a href="#sundair-logout" class="">{{ agencylogout[getCurrentLocale] }}</a>
                </li> -->
            </ul>
        </nav>
        <!-- End:Navbar-mobile -->
    </div>
</template>

<script>
    import Vue from 'vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ----------------
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                // >>> ----------------
                agencylogin: {
                    en: 'Agency Login',
                    de: 'Agentur Login',
                },
                agencylogout: {
                    en: 'Agency Logout',
                    de: 'Agentur Logout',
                },
                // >>> ----------------
                booking: {
                    en: 'Flight Booking',
                    de: 'Flugbuchung',
                },
                services: {
                    en: 'Seats and Services',
                    de: 'Sitzplätze und Services',
                },
                rebooking: {
                    en: 'Rebooking',
                    de: 'Umbuchung',
                },
                mybookings: {
                    en: 'My Bookings',
                    de: 'Meine Buchungen',
                },
                flightplan: {
                    en: 'Flight plan',
                    de: 'Flugplan',
                },
                pressreleases: {
                    en: 'Press Releases',
                    de: 'Presse',
                },
                career: {
                    en: 'Career',
                    de: 'Karriere',
                },
                agency: {
                    en: 'Agency',
                    de: 'Agentur',
                },
                travelcenter: {
                    en: 'My Travelcenter',
                    de: 'Meine Reisezentrale',
                },
                flightstatus: {
                    en: 'Flightstatus',
                    de: 'Flugstatus',
                },
                webshop: {
                    en: 'Webshop',
                    de: 'Webshop',
                },
                // >>> ----------------
                dialogtitle: {
                    en: 'Change Language?',
                    de: 'Sprache ändern?',
                },
                dialogtext: {
                    en: 'You want to change the language?',
                    de: 'Sie wollen die Sprache ändern?',
                },
                alertno: {
                    en: 'No',
                    de: 'Nein',
                },
                alertyes: {
                    en: 'Yes',
                    de: 'Ja',
                },
                // >>> ------------------------------------
                currentUrl: '',
                lang: 'de'
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn', // is Agency logged in?
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Check for Agency here. If so ... show some Green.
        *
        */
		mounted: function () {

            let me = this,
                localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username')), // catch
                localStorageAgencyPass = JSON.parse(localStorage.getItem('sdr__agency_password')); // catch


            // >>> Agency in localStorage? --------------
            if (localStorageAgencyUser !== null) {
                this.actn_FlagSharedAgencyLoggedIn(true);
            }

        }, // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_FlagSharedAgencyLoggedIn', //
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_AgencyLogout()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return
            */
            onClick_AgencyLogout: function () {

                var me = this;


                me.$toc('>>> shared/header/NavbarMain.vue >>> onClick_AgencyLogout');
                Vue.ls.remove('agency_username');
                Vue.ls.remove('agency_password');
                Vue.ls.remove('agency_object');
                Vue.ls.remove('agencyAuthorizationHeader');

                this.actn_FlagSharedAgencyLoggedIn(false);
                me.$toasted.global.sdr_app_info({
                    message : 'Agency was logged out.'
                });

            }, // eo funtion onClick_AgencyLogout()




            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * changeLanguage()
            *
            * Desc:
            * Note:
            *
            * @param {string} language ()
            * @param
            * @return
            */
            changeLanguage: function (language) {

                var me = this;


                me.$toc('>>> shared/header/NavbarMain.vue >>> changeLanguage');
                this.$modal.show('dialog', {
                    title: me.dialogtitle[me.getCurrentLocale],
                    text:  me.dialogtext[me.getCurrentLocale],
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {
                                me.$modal.hide('dialog');
                                me.lang = language;
                                this.$ls.set('lang', language); // localStorage

                                me.actn_setCurrentLocale(language);
                            }
                        }
                    ]
                });

            }, // eo function changeLanguage()


            /*******************************************************************
            * getPathName()
            *
            * Desc:
            * Note:
            *
            * @param {string} pathname ()
            * @param
            * @return
            */
            getPathName: function (pathname) {

                var me = this,
                    currentUrl = window.location.pathname,
                    currentUrl = currentUrl.slice(1,-1);


                // me.$toc('>>> shared/header/LanguageList.vue >>> getPathName');
                if (pathname === currentUrl) {
                    return true;
                } else {
                    return false;
                }

            }, // eo function getPathName()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
.menu-color-skin ul.menu.mini, .menu-color-blue ul.menu.mini, .menu-color-yellow ul.menu.mini, .menu-color-green ul.menu.mini {
        background: #ec008b;
    }
    .menu-color-skin ul.menu.mini li:hover, .menu-color-blue ul.menu.mini li:hover, .menu-color-yellow ul.menu.mini li:hover, .menu-color-green ul.menu.mini li:hover, .menu-color-skin ul.menu.mini li.active, .menu-color-blue ul.menu.mini li.active, .menu-color-yellow ul.menu.mini li.active, .menu-color-green ul.menu.mini li.active {
        background: #ec008b;
    }

    #header .mobile-menu .mobile-topnav > li > a {
        font-size: 0.8333em;
        padding: 0 10px;
        margin: 22px 10px;
        line-height: 1em;
        width: auto;
        text-transform: uppercase;
    }

    .agencyisloggedin  {
        background-color: #3bdd4e !important;
    }


    a[id="_new"]:after {
        font-family: 'FontAwesome';
        content: " \f0a2";
    }
</style>





// WEBPACK FOOTER //
// src/components/shared/header/NavbarMain.vue